import { render, staticRenderFns } from "./ViewPackagePage.vue?vue&type=template&id=9cb37bba"
import script from "./ViewPackagePage.vue?vue&type=script&lang=js"
export * from "./ViewPackagePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports